import React, { Component } from 'react'
import { Container } from 'reactstrap'

export default class ViewNotice extends Component {

    constructor(props) { super(props) }

    render() {
        const { notice } = this.props
        return (
            <Container fluid className="container-card-detalhe-anexos">
                <div dangerouslySetInnerHTML={{ __html: notice.Body }} />
            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/notices/components/ViewNotice.js